module.exports = __webpack_public_path__ + "img/a63f91a.jpg";